import styled from 'styled-components';
import ButtonBase from 'components/ButtonBase';
import { THUMBNAIL_BORDER_RADIUS } from 'components/Thumbnail';

export const Button = styled(ButtonBase)`
  background-color: transparent;
  border-radius: ${THUMBNAIL_BORDER_RADIUS};
  box-shadow: none;
  position: relative;
  width: 100%;
  transition: ${({ theme }) =>
    theme.transitions.create(['box-shadow', 'transform'], '300ms')};

  &,
  &[data-hovered='true'],
  &:active:not([disabled]) {
    box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.15);
  }

  &[data-hovered='true'] {
    transform: scale(1.03125);
  }
`;

export const PlayButtonContainer = styled.div`
  opacity: 0;
  position: absolute;
  transition: ${({ theme }) => theme.transitions.create('opacity', '300ms')};

  ${Button}[data-hovered='true'] & {
    opacity: 1;
  }
`;
